// Axios
import Axios from "./axios"

export const getNewsById = (id) => {
    return new Promise((resolve, reject) => {
        const data = Axios.get(`news/${id}`)
        setTimeout(() => resolve(data), 0)
    })

}